import React, { FC } from "react";
import { readObj } from "Service/storage";
import { ReactComponent as User } from "Assets/user-removebg-preview.svg";
type TProps = {
  className?: string;
};
export const Profile: FC<TProps> = ({ className }) => {
  const personalInfo = readObj("account");
  return (
    <>
      {personalInfo && personalInfo.profile_picture ? (
        <img
          src={personalInfo.profile_picture.file}
          className={className}
          alt="User Profile"
        />
      ) : (
        <User className={className} />
      )}
    </>
  );
};
